import { QueryClient } from "@tanstack/react-query";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export function accountPreferencesViewLoader(queryClient: QueryClient) {
  queryClient.prefetchQuery(USERS_QUERIES.profile());
}
